import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { format, classNames } from '@dt/fe-utils'
import { doProductMobx, menuMobx } from 'restaurant'
import './index.scss'
import { decorationMobx } from '@mobxStore'
import { filter, sortBy } from '@dt/fe-utils/dist/lodash'
import doProduct from 'restaurant/mobx/doProduct.mobx'
import { SoldoutFoldBar } from '@cps'

interface IProps {
  disableScale?: boolean;
  hidePrice?: boolean;
}

const CnScales: React.FC<IProps> = ({ disableScale, hidePrice }) => {
  const showScales = useMemo(() => {
    return doProductMobx.doProduct.scales?.length > 1 || doProductMobx.doProduct.scales?.[0]?.name || doProductMobx.doProduct.isOpenPrice
  }, [doProductMobx.doProduct.scales])

  const handleSelectScale = (item) => {
    if (item.saleCnt === 0 || disableScale || item.disable) {
      return
    }
    doProductMobx.selectScale(item.no)
  }

  // 过滤时价
  const _scales = useMemo(() => doProductMobx.doProduct.isScaleOpenPrice ? filter(doProductMobx.doProduct.scales, (scales) => !scales.isOpenPrice) : doProductMobx.doProduct.scales, [doProductMobx.doProduct])

  // 售罄子餐品数量
  const soldoutCnt = filter(_scales, scale => scale.saleCnt === 0).length
  const showSoldout = menuMobx.openFoldSoldoutScale === 1 && soldoutCnt > 0
  const soldoutKey = `${doProductMobx.doProduct.no}_scale`
  const scales = useMemo(() => {
    return !showSoldout || menuMobx.foldSoldoutMap?.[soldoutKey] === true ? sortBy(_scales || [], (scale) => scale.saleCnt === 0 ? 1 : 0) : filter(_scales, scale => scale.saleCnt !== 0)
  }, [_scales, menuMobx.foldSoldoutMap?.[soldoutKey], showSoldout])

  return (
    <>
      {
        showScales ? (
          <div
            className={classNames('choose-scale-list', {
              'disable-scale': disableScale,
              'hide-price': disableScale || hidePrice
            })}
          >
            <div className='title space-between'>
              <span>{doProductMobx.doProduct.scaleGroupName}</span>
              <span>{i18n.t('productdetail.requireCount', { count: 1 })}</span>
            </div>
            <div className='item-list'>
              {
                scales.map(item => {
                  return (
                    <div
                      className={`item${item.no === doProductMobx.doProduct.scaleNo ? ' selected' : ''}${item.saleCnt === 0 ? ' sold-out' : ''}${item.disable ? ' disabled' : ''}`}
                      key={item.no}
                      data-cypid={`chooseScale_no_${item.no}`}
                      onClick={() => handleSelectScale(item)}
                    >
                      <div
                        className='info'
                      >
                        {item.picArr?.length ? <img className='pic' src={item.no === doProductMobx.doProduct.scaleNo ? item.picArr[1] : item.picArr[0]} /> : null}
                        {!item.picArr?.length && item.pic ? (<i className={`iconfont icon-${item.pic}${item.no === doProductMobx.doProduct.scaleNo ? 'xuanzhong' : ''}2x`} />) : null}
                        <span className='name'>{item.name}</span>
                        {!!(item.pic && item.remark) && (<span className='scale-remark'>{item.remark}</span>)}
                        {item.saleCnt !== 0 && <div className='price'>{format.toPrice(item.actualPrice)} {!!(item.discountPrice && item.discountPrice > 0) && <del> {format.toPrice(item.price)}</del>}</div>}
                        {item.saleCnt >= 0 && (
                          <div className='sub-price-limit'>
                            {item.saleCnt > 0 ? (
                              decorationMobx.mealDecorates.showSalesCnt ? <span>{`(${i18n.t('cart.limit')}: ${item.saleCnt})`}</span> : null
                            ) : (
                              <span>{i18n.t('common.soldout')}</span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })
              }
              {!!showSoldout && (
                <SoldoutFoldBar
                  cnt={soldoutCnt}
                  className='item'
                  show={menuMobx.foldSoldoutMap?.[soldoutKey] === true}
                  no={soldoutKey}
                  from='scale'
                />
              )}
            </div>
          </div>
        ) : null
      }
    </>
  )
}

export default observer(CnScales)
